// assets/section-social-proof.js
document.addEventListener("DOMContentLoaded", function() {
  const sliderHolder = document.querySelector('.social-proof-container-holder');
  const dots = document.querySelectorAll('.dot');
  let currentSlide = 0;

  // Update slider transform and dot appearance only for mobile/iPad sizes
  function updateSlider() {
    if (window.innerWidth < 768) {
      const slideElement = sliderHolder.querySelector('.social-proof-container');
      const style = window.getComputedStyle(slideElement);
      const marginLeft = parseFloat(style.marginLeft);
      const marginRight = parseFloat(style.marginRight);
      const effectiveSlideWidth = slideElement.offsetWidth + marginLeft + marginRight; // calculates total slide width
      const translation = currentSlide * effectiveSlideWidth;
      sliderHolder.style.transform = `translateX(-${translation}px)`;
      sliderHolder.style.transition = 'transform 0.3s';
      document.querySelector('.dots-container').style.display = 'flex';
      dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === currentSlide);
      });
    } else {
      sliderHolder.style.transform = 'none';
      document.querySelector('.dots-container').style.display = 'none';
    }
  }

  // Attach click events to each dot
  dots.forEach((dot, index) => {
    dot.addEventListener('click', function() {
      currentSlide = index;
      updateSlider();
    });
  });

  window.addEventListener('resize', updateSlider);
  updateSlider();

  // Auto-cycle through slides every 3 seconds on mobile/iPad sizes
  setInterval(function() {
    if (window.innerWidth < 768) {
      currentSlide = (currentSlide + 1) % dots.length;
      updateSlider();
    }
  }, 6000);
});